// ScegliLingua.tsx — elenco delle lingue (v019, dalla Home). v030: una lingua per riga con la bandiera, il nome
// nella lingua stessa e, sotto, nella lingua dell'app; quella scelta ha la spunta.
import { vibra } from "../servizi/nativo.ts";
import { useTranslation } from "react-i18next";
import { BANDIERE, nomeIn, nomeNativo } from "../i18n/index.ts";
import { tastiRadio } from "./tastiRadio.ts";

export function ScegliLingua({ lingue, lingua, onLingua }: { lingue: readonly string[]; lingua: string; onLingua: (l: string) => void }) {
  const { t } = useTranslation();
  return (
    <div className="ld-lingue" role="radiogroup" aria-label={t("lingua.titolo")} onKeyDown={tastiRadio}>
      {[...lingue]
        .map((l) => ({ l, nome: nomeNativo(l), qui: l === lingua ? null : nomeIn(l, lingua) }))
        .sort((a, b) => a.nome.localeCompare(b.nome))
        .map(({ l, nome, qui }) => (
          <button key={l} type="button" role="radio" aria-checked={l === lingua} tabIndex={l === lingua ? 0 : -1} className="ld-lingue-voce" onClick={() => {
              vibra("scelta");
              onLingua(l);
            }}>
            {BANDIERE[l] && <img className="ld-lingue-bandiera" src={`/bandiere/${BANDIERE[l]}.svg`} alt="" width={32} height={24} loading="lazy" />}
            <span className="ld-lingue-nomi">
              <span lang={l} className="ld-lingue-nome">
                {nome}
              </span>
              {qui && qui !== nome && <span className="ld-lingue-qui">{qui}</span>}
            </span>
            {l === lingua && (
              <svg className="ld-lingue-spunta" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M5 12.5l4.5 4.5L19 7.5" />
              </svg>
            )}
          </button>
        ))}
    </div>
  );
}
